<template>
    <div class="xslx-uploader-view">
        <input type="file" @change="filesChange" class="form-control">
    </div>
</template>

<script>
import XLSX from "xlsx";

export var XLSXParseUtil = function(workbook) {
    this.workbook = workbook;
};
Object.assign(
    XLSXParseUtil,
    {
        fromFileUpload: function(fileObj) {
            return new Promise((resolve) => {
                var reader = new FileReader();
                reader.onload = function(event) {
                    resolve({
                        file: fileObj,
                        xlsx: new XLSXParseUtil(
                            XLSX.read(
                                new Uint8Array(event.target.result),
                                {type: 'array'}
                            )
                        )
                    });
                };
                reader.readAsArrayBuffer(fileObj);                    
            });
        }
    }
);
Object.assign(
    XLSXParseUtil.prototype,
    {
        colLabels: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
        nextColLabel: function(colLabel) {
            var colLabelLeastSignificant, colLabelLeastSignificantIdx;
            if (colLabel == "") {
                return "A";
            } else {
                colLabelLeastSignificant = colLabel.substr(colLabel.length - 1, 1);
                colLabelLeastSignificantIdx = this.colLabels.indexOf(colLabelLeastSignificant);
                if (colLabelLeastSignificantIdx == (this.colLabels.length - 1)) {
                    return (
                        this.nextColLabel(colLabel.substr(0, colLabel.length - 1)) +
                        "A"
                    )
                } else {
                    return (
                        colLabel.substr(0, colLabel.length - 1) +
                        this.colLabels[colLabelLeastSignificantIdx + 1]
                    );
                }
            }
        },
        getCellValue: function(worksheet, cellIdx) {
            //var v = worksheet[cellIdx] ? worksheet[cellIdx].v : "";
            var v = worksheet[cellIdx] ? worksheet[cellIdx].w : "";
            switch (typeof v) {
                case "string":
                    // do nothing
                    break;
                case "number":
                case "boolean":
                    v = v.toString();
                    break;
                default:
                    v = "";
            }
            return v;
        },
        makePropertyName: function(cellValue) {
            return cellValue.toLowerCase().replace(/[^a-z0-9_]/g, " ").replace(/\s+/g, " ").replace(/^\s+/g, "").replace(/\s+$/g, "").replace(/ /g, "_").replace(/_+/g, "_");
        },
        parsePropertiesValuesBlock: function (
            worksheetIdx,
            colGroup,
            colProperty,
            colValue,
            rowStart,
            maxEmptyRows
        ) {
            var worksheet = this.workbook.Sheets[worksheetIdx];
            var state = "start";
            var rowNumber = rowStart || 1;
            var groups = {};
            var cellValue, emptyRowCount, groupName;
            
            maxEmptyRows = maxEmptyRows || 1;

            emptyRowCount = 0;
            while (emptyRowCount <= maxEmptyRows) {
                switch(state) {
                    case "start":
                        cellValue = this.getCellValue(worksheet, `${colGroup}${rowNumber}`);
                        //console.log(`${colGroup}${rowNumber}`, cellValue);
                        if (cellValue) {
                            emptyRowCount = 0;
                            groupName = this.makePropertyName(cellValue);
                            groups[groupName] = {};
                            state = "headers";
                        } else {
                            emptyRowCount++;
                        }
                        break;
                    case "headers":
                        cellValue = this.getCellValue(worksheet, `${colProperty}${rowNumber}`);
                        if (cellValue) {
                            state = "properties"
                        } else {
                            emptyRowCount++;
                        }
                        break;
                    case "properties":
                        cellValue = this.getCellValue(worksheet, `${colGroup}${rowNumber}`);
                        if (cellValue) {
                            emptyRowCount = 0;
                            rowNumber--;
                            state = "start";
                        } else {
                            cellValue = this.getCellValue(worksheet, `${colProperty}${rowNumber}`);
                            if (cellValue) {
                                emptyRowCount = 0;
                                groups[groupName][this.makePropertyName(cellValue)] = this.getCellValue(worksheet, `${colValue}${rowNumber}`);
                            } else {
                                emptyRowCount++;
                            }
                        }
                        break;
                }
                rowNumber++;
            }
            //console.log(groups);
            return groups;
        },
        parseTableBlock: function (
            worksheetIdx,
            headerColStart,
            headerRowStart,
            maxEmptyRows,
            maxTableRows
        ) {
            var worksheet = this.workbook.Sheets[worksheetIdx];
            var colLabel = headerColStart;
            var rowNumber = headerRowStart;
            var emptyRowCount = 0;
            var rowCount = 0;
            var state = "start"
            var headers = [];
            var rows = [];
            var cellValue, existsCellValue, row, emptyRow;

            maxEmptyRows = maxEmptyRows || 0;
            maxTableRows = ((maxTableRows === null) || (typeof maxTableRows == "undefined")) ? null : 1 + maxTableRows; // Add 1 to account for the header

            while (emptyRowCount <= maxEmptyRows) {
                if (
                    (maxTableRows !== null) &&
                    !(rowCount < maxTableRows)
                ) {
                    break;
                }
                emptyRow = false;
                switch (state) {
                    case "start":
                        cellValue = this.getCellValue(worksheet, `${colLabel}${rowNumber}`);
                        if (cellValue != "") {
                            // eslint-disable-next-line
                            while (true) {                                
                                if (cellValue != "") {
                                    headers.push(this.makePropertyName(cellValue));
                                    colLabel = this.nextColLabel(colLabel);
                                    cellValue = this.getCellValue(worksheet, `${colLabel}${rowNumber}`);
                                } else {
                                    state = "fields";
                                    rowNumber++;
                                    break;
                                }
                            }
                        } else {
                            emptyRow = true;
                        }
                        break;
                    case "fields":
                        existsCellValue = false;
                        row = {};
                        colLabel = headerColStart;
                        headers.forEach((header) => {
                            row[header] = this.getCellValue(worksheet, `${colLabel}${rowNumber}`);
                            if (row[header] != "") {
                                existsCellValue = true;
                            }
                            colLabel = this.nextColLabel(colLabel);
                        });
                        if (existsCellValue) {
                            rows.push(row);
                        } else {
                            emptyRow = true;
                        }
                        rowNumber++;
                        break;
                }
                if (emptyRow) {
                    emptyRowCount++;
                }
                rowCount++;
            }
            return rows;
        }
    }
);

export default {
    name: 'XLSXUploader',
    methods: {
        addFiles: function(filesParam) {
            var files = [];
            var filesOut = [];
            var addNextFile = () => {
                if (files.length) {
                    return XLSXParseUtil.fromFileUpload(
                        files.shift()
                    ).then(
                        (xlsx) => {
                            filesOut.push(xlsx);
                            return addNextFile();
                        }
                    );
                } else {
                    return Promise.resolve(filesOut);
                }
            };
            for (var i = 0; i < filesParam.length; i++) {
                files.push(filesParam[i]);
            }
            return addNextFile();
        },
        filesChange: function(event) {
            if (event.target.files) {
                this.addFiles(
                    event.target.files
                ).then(
                    (files) => {
                        this.$emit("XLSXUploader:uploaded", files);
                        event.target.value = "";
                    }
                )
            }
        }
    }
}
</script>

<style lang="scss"></style>